import { computed, Injectable, signal } from '@angular/core';
import { MemberBadgeItem } from './member-badge-group.interfaces';
import { MemberOption } from '../member-multiselect-input/member-multiselect-input.interfaces';

@Injectable()
export class MemberBadgeGroupStore {
  /** Input mirrors — synced from component inputs via effects */
  readonly members = signal<MemberBadgeItem[]>([]);
  readonly maxVisible = signal(3);
  readonly options = signal<MemberOption[]>([]);

  /** Local mutable state */
  readonly isActive = signal(false);
  readonly localSelectedIds = signal<string[]>([]);

  /** Derived state */
  readonly selectable = computed(() => this.options().length > 0);
  readonly visibleMembers = computed(() => this.members().slice(0, this.maxVisible()));
  readonly overflowCount = computed(() => Math.max(0, this.members().length - this.maxVisible()));
  readonly hasOverflow = computed(() => this.overflowCount() > 0);

  toggleMember(memberId: string): string[] {
    const current = this.localSelectedIds();
    const isSelected = current.includes(memberId);
    const updated = isSelected ? current.filter(id => id !== memberId) : [...current, memberId];
    this.localSelectedIds.set(updated);
    return updated;
  }
}
